
import React from "react";
import { useDebugMode } from "@/hooks/useDebugMode";
import { Bug } from "lucide-react";
import { Button } from "@/components/ui/button";
import CacheToggle from "@/components/CacheToggle";

const DebugModeToggle = () => {
  const isDebugMode = useDebugMode();

  // This is only visible in the Lovable development environment
  if (process.env.NODE_ENV === "production") {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 flex gap-2">
      <CacheToggle />
      
      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          // Add query parameter to enable/disable debug mode
          const url = new URL(window.location.href);
          if (isDebugMode) {
            url.searchParams.set("debug", "false");
          } else {
            url.searchParams.set("debug", "true");
          }
          window.history.pushState({}, "", url.toString());
          // Reload to apply the change
          window.location.reload();
        }}
        className={`flex items-center gap-1 text-xs ${
          isDebugMode ? "bg-amber-100" : ""
        }`}
      >
        <Bug className="h-4 w-4" />
        {isDebugMode ? "Debug: ON" : "Debug: OFF"}
      </Button>
    </div>
  );
};

export default DebugModeToggle;
